const etat = {
  NON_LU: "NON LU",
  LU: "LU",
  REPONDU: "REPONDU",
};

export default {
  etat,
};
